import { render, staticRenderFns } from "./DocSubMenu.vue?vue&type=template&id=bbd19936&scoped=true&"
import script from "./DocSubMenu.vue?vue&type=script&lang=js&"
export * from "./DocSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./DocSubMenu.vue?vue&type=style&index=0&id=bbd19936&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd19936",
  null
  
)

export default component.exports